import { render, staticRenderFns } from "./wellve.vue?vue&type=template&id=7525fe4a&lang=pug&"
import script from "./wellve.vue?vue&type=script&lang=js&"
export * from "./wellve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports